class TicketEventController extends AbstractEntityEditController
	@register()
	@inject 'translate',
		'ticketEvent'
		'Guid'
		'TicketEventRepository'
		'TicketEventSessionRepository'
		'CopyService'
		'parseBool'

	initialize: ->
		@mainCrud.entityType = 'general.ticket_event'
		@mainCrud.entityTitle = 'general.new.ticket_event'
		@mainCrud.deletionAlertText = @translate('wbo.ticket_event.delete.confirm')
		@sequenceNumber = 1
		@colspan = 6

		if @ticketEvent.id?
			@mainCrud.entityTitle = @ticketEvent.name
			@mainCrud.isNewEntity = false
			@colspan = 7

			@mainCrud.additionalButtons = [
				{
					action: 'copy'
					label: 'general.copy'
					confirmClick: => @copy()
					confirmClickLabel: 'general.copy.confirm'
				}
			]
		else
			@ticketEvent.start_date = moment().unix()
			@ticketEvent.allow_rejoin = '1'

		if !@ticketEvent.sessions? || @ticketEvent.sessions.length == 0
			@ticketEvent.sessions ?= []
			@addSession(true)
		else
			@sequenceNumber = _.max(@ticketEvent.sessions, (session) -> parseInt(session.sequence_number)).sequence_number
			@sequenceNumber = parseInt(@sequenceNumber) + 1
			@mapTicketCountsToSessions()

		for session in @ticketEvent.sessions
			session.is_active = @parseBool(session.is_active)

		@datePickerConfig =
			timePicker: true
			singleDatePicker: true
			timePickerIncrement: 5
			minDate: if @mainCrud.isNewEntity then moment() else 0

		@sessionDatePickerConfig = angular.copy @datePickerConfig

		@mainCrud.tabs = [
			{
				active: true
				title: 'wbo.tab.details'
				selector: '#tab-details'
			}
			{
				title: 'general.ticket_event.sessions'
				selector: '#tab-sessions'
			}
		]
		@sortSessions()

	copy: ->
		if @mainCrud.isNewEntity
			console.warn('Can not copy new entity')

			return

		@saveEntity(
			@CopyService.copyEntity(
				@ticketEvent,
				{sessions: ['ticket_event_id']}
			),
			true
		)

	save: ->
		@saveEntity(@CopyService.copy(@ticketEvent))

	saveEntity: (entity, isNewEntity = @mainCrud.isNewEntity) ->
		if !@validateSessions()
			return

		@mainCrud.saving = true

		@TicketEventRepository
			.save(entity, isNewEntity)
			.then (response) =>
				@afterSave(response, @mainCrud.entityType, isNewEntity)
			.catch (response) =>
				@handleErrors response, 'general.ticket_event'

	delete: ->
		@deleteEntity(@TicketEventRepository, @ticketEvent)

	validateSessions: ->
		@resetErrors()

		for session in @ticketEvent.sessions
			if session.start_date < @ticketEvent.start_date or (session.end_date? and session.start_date >= session.end_date)
				@addErrorMessage("\##{session.sequence_number} #{session.name or ''}", 'general.ticket_event.session.error.start_date')

			if @ticketEvent.end_date? and session.end_date > @ticketEvent.end_date
				@addErrorMessage("\##{session.sequence_number} #{session.name or ''}", 'general.ticket_event.session.error.end_date')

		valid = !@hasErrorMessages()

		@mainCrud.parent_form.$setValidity('session', valid)

		return valid

	sortSessions: ->
		@ticketEvent.sessions = _.sortBy @ticketEvent.sessions, (session) => parseInt(session.sequence_number)

	addSession: (isInitial = false) ->
		@onChange session, isInitial
		session =
			id: @Guid.generate()
			start_date: @ticketEvent.start_date
			end_date: @ticketEvent.end_date
			is_active: '1'
			sequence_number: "#{@sequenceNumber}"
			is_new: true

		@ticketEvent.sessions.push session
		@sequenceNumber++

		@validateSessions()

	removeSession: (session) ->
		@mainCrud.parent_form.$setDirty()
		@ticketEvent.sessions = _.reject(@ticketEvent.sessions, {id: session.id})

		@validateSessions()

	onDateChange: (date, dateType, session = null) ->
		@onChange session

		if not session?
			dateRestrictionType = if dateType == 'end_date' then 'maxDate' else 'minDate'
			@sessionDatePickerConfig[dateRestrictionType] = date

			# Auto update session times
			for eventSession in @ticketEvent.sessions
				eventSession.start_date = @ticketEvent.start_date if eventSession.start_date < @ticketEvent.start_date
				eventSession.end_date = @ticketEvent.end_date if eventSession.end_date > @ticketEvent.end_date

		@validateSessions()

	onChange: (session = null, isInitial = false) ->
		if session?
			session.is_changed = true

		if !isInitial
			@mainCrud.parent_form.$setDirty()

	mapTicketCountsToSessions: ->
		@TicketEventSessionRepository
			.getTicketCounts(@ticketEvent.id)
			.then (sessionTicketCounts) =>
				@ticketEvent.sessions = _.map @ticketEvent.sessions, (session) =>
					sessionTicketCount = _.find(sessionTicketCounts, {ticket_event_session_id: session.id})

					if _.isEmpty sessionTicketCount
						session.ticket_count = 0
					else
						session.ticket_count = sessionTicketCount.count

					return session
